import Service, { getCallApiFunction } from '../service'

export type TimeLineLiveType = 'live' | 'product' | 'vip'

export type ParamsType = {
  type: TimeLineLiveType
  pageSize?: number
  memberInfoId: string
  cursorId?: string
}

class FetchMemberTimelineApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_MEMBER_TIMELINE'

    this.config = {
      url: `/v1/livemall/member/timeline`,
      method: 'GET',
      params,
    }
  }
}

export const fetchMemberTimeline = (params: ParamsType) => getCallApiFunction(new FetchMemberTimelineApi(params))
